import FavoriteButton from '@liveauctioneers/caterwaul-components/lib/FavoriteButton/FavoriteButton';
import React from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { EventContext } from '@/redux/modules/analytics';
import { toggleItemSave } from '@/redux/modules/item/saved/savedItems.actions';
import { isItemSaved } from '@/redux/modules/item/saved/savedItems.selectors';
import { CompleteAccountModalContext, ModalContext } from '@/redux/modules/modal';

type Props = {
    catalogId: number;
    imageUrl: string;
    itemId: number;
    itemUnavailable: boolean;
};

// TODO wait for API that get's the more current data
// type BidderLotStatus = '' | 'leading' | 'won' | 'lost' | 'outbid';

const LotImageContainer = ({ catalogId, imageUrl, itemId, itemUnavailable }: Props) => {
    // TODO wait for API that get's the more current data
    // const { bidderHasBid, bidderHasHighBid, bidderWonItem, isSold } = useAppSelector((state) =>
    //     getItemSummary(state, itemId)
    // );

    const dispatch = useAppDispatch();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const isFavorite = useAppSelector((state) => isItemSaved(state, itemId));
    const location = useLocation();

    const modalContext = React.useMemo<ModalContext>(
        () => ({
            eventContext: EventContext.saveItem,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.SaveItem,
        }),
        [itemId]
    );

    // TODO wait for API that get's the more current data
    // // Data for live item
    // const currentLiveItemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    // const currentBidderId = useAppSelector(getBidderId);
    // const leadingBidder = useAppSelector((state) => getLiveItemDataLeadingBidder(state, itemId));
    // const liveBidderHasHighBid = useAppSelector((state) => getBidderHasHighBid(state));
    // const myBid = leadingBidder === currentBidderId;
    // const isCurrentLiveItem = currentLiveItemId === itemId;
    // // console.log(isCurrentLiveItem);

    const onToggleFavorite = React.useCallback(() => {
        dispatch(toggleItemSave({ canHaveEasyShippingTag: false, catalogId, itemId, location }));
    }, [dispatch, itemId, catalogId, location]);

    // TODO wait for API that get's the more current data
    // let statusMessage: BidderLotStatus = '';
    // if ((bidderHasHighBid || myBid) && !isSold) {
    //     statusMessage = 'leading';
    // } else if ((isSold && bidderHasHighBid) || bidderWonItem) {
    //     statusMessage = 'won';
    // } else if (!bidderHasHighBid && isSold) {
    //     statusMessage = 'lost';
    // } else if (!bidderHasHighBid && !isSold) {
    //     statusMessage = 'outbid';
    // }

    // console.log({
    //     liveBidderHasHighBid,
    //     myBid,
    // });

    // const showStatus = bidderHasBid || myBid;

    return (
        <ImageContainer $itemUnavailable={itemUnavailable}>
            {!isFavorite && (
                <HeartIconContainer className="heart-icon">
                    <ShouldLogInContainer
                        forceSignUp={!userLoggedIn}
                        modalContext={modalContext}
                        runFunction={onToggleFavorite}
                    >
                        <FavoriteButton data-testid="favorite-button" />
                    </ShouldLogInContainer>
                </HeartIconContainer>
            )}
            {isFavorite && (
                <HeartIconContainerFavorited>
                    <FavoriteButton
                        data-testid="unfavorite-button"
                        onClick={onToggleFavorite}
                        selected
                    />
                </HeartIconContainerFavorited>
            )}
            <img
                data-testid="lot-image"
                src={imageUrl}
            />

            {/*  TODO wait for API that get's the more current data */}
            {/* {showStatus && (
                <StatusContainer $status={statusMessage}>
                    <Status>{statusMessage}</Status>
                </StatusContainer>
            )} */}
        </ImageContainer>
    );
};

export default LotImageContainer;

const ImageContainer = styled.div<{ $itemUnavailable: boolean }>`
    height: 78px;
    width: 78px;
    min-width: 78px;
    min-height: 78px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    position: relative;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        ${({ $itemUnavailable }) =>
            $itemUnavailable &&
            css`
                opacity: 0.5;
            `}
    }
`;

// const StatusContainer = styled.div<{ $status: BidderLotStatus }>`
//     position: absolute;
//     bottom: 0;
//     width: 100%;
//     height: fit-content;
//     text-align: center;
//     ${({ $status }) => {
//         if ($status === 'won' || $status === 'leading') {
//             return css`
//                 background: ${({ theme }) => theme.colors.green100};
//             `;
//         }
//         if ($status === 'outbid') {
//             return css`
//                 background: ${({ theme }) => theme.colors.red100};
//             `;
//         }
//         if ($status === 'lost') {
//             return css`
//                 background: ${({ theme }) => theme.colors.grey100};
//             `;
//         }
//     }}
// `;

// const Status = styled(Text)`
//     color: ${({ theme }) => theme.colors.white};
//     letter-spacing: 1px;
//     font-size: 12px;
//     font-weight: 500;
//     text-transform: uppercase;
// `;

const HeartIconContainer = styled.div`
    display: none;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 2;
`;

const HeartIconContainerFavorited = styled(HeartIconContainer)`
    display: block;
    z-index: 2;
`;
